export const ANALYTICS_ACCESS = {
    user: 'admin.analytics.user-analytics',
    list: 'admin.analytics.list',
    org: 'admin.analytics.org-analytics',
};

export const CLIENTS = { list: 'admin.organizations.client.list' };

export const MY_PROFILE = { update: 'admin.users.users-update-profile' };

export const APP_UPDATE_ACCESS = {
    list: 'admin.app_update.list',
    store: 'admin.app_update.store',
    update: 'admin.app_update.update',
    delete: 'admin.app_update.delete',
};

export const AUTHOR_ACCESS = {
    list: 'admin.author.list',
    store: 'admin.author.store',
    update: 'admin.author.update',
    delete: 'admin.author.delete',
    toggleAuthor: 'admin.author.change-status',
};

export const SCHOLARSHIP_ACCESS = {
    list: 'all', // TODO: Permissions not available
    uploadScholarship: 'all', // TODO: Permissions not available
};

export const BATCH_ATTENDANCE = {
    scheduleDetails: 'admin.batches.schedules.details',
    slidePreview: 'all', // TODO: Permissions not available
    scheduleChat: 'all', // TODO: Permissions not available
    assignScheduleToOtherBatch: 'all', // TODO: Permissions not available
    getTotalUsers: 'admin.chat_users.list',
};

export const BATCH_COMMUNITY = {
    listCommunity: 'admin.community.users',
    assignRole: 'admin.community.update_user',
    bulkTeacherAllotment: 'admin.community.update_batch_csv',
};

export const BATCH_THREE_D_MODEL = {
    list: 'admin.batches.schedules.three.d.model.list',
    create: 'admin.batches.schedules.three.d.model.create',
    edit: 'admin.batches.schedules.three.d.model.update',
    delete: 'admin.batches.schedules.three.d.model.delete',
};

export const BATCH_SUPER40 = {
    listSuper40: 'admin.community.super40Channels',
    addChannel: 'admin.community.post_super40Channels',
    editChannel: 'admin.community.update_channel',
    bulkAssignMentor: 'admin.community.assign_batch_mentors',
    downloadExcel: 'admin.community.download_super40',
    listChannelMembers: 'admin.community.members_channel',
    listChannelMentors: 'admin.community.get_mentors',
    muteChannelMember: 'admin.community.users_mute_channel',
    bulkStudentAllotment: 'admin.community.users_super40',
    removeMentor: 'admin.community.remove_mentor',
};

export const LCM_ACCESS = { blockHistory: 'admin.lcm.get_block_history' };

export const STUDY_MATERIAL_ACCESS = {
    list: 'admin.student-engagement-core.listexamswithcategories',
    storeAndUpdate: 'admin.student-engagement-core.generatehierarchy',
    delete: 'admin.student-engagement-core.deletehierarchy',
};

export const BATCH_ACCESS = {
    list: 'admin.batches.list',
    store: 'admin.batches.store',
    update: 'admin.batches.update',
    delete: 'admin.batches.delete',
    show: 'admin.batches.show',
    listOverview: 'all', // TODO: Permissions not available
    batchTagList: 'admin.batches.tags.list',
    batchTagStore: 'admin.batches.tags.store',
    batchTagUpdate: 'admin.batches.tags.update',
    batchTagVideos: 'admin.batches.tags.tagVideosList',
    batchTagDownloadIds: 'all', // TODO: Permissions not available
    listClasses: 'all', // TODO: Permissions not available
    batchScheduleDoubtPreview: 'all', // TODO: Permissions not available
    batchTagDelete: 'admin.batches.tags.delete',
    addAnnouncement: 'admin.batches.announcement.store',
    listAnnouncement: 'admin.batches.announcement.list',
    deleteAnnouncement: 'admin.batches.announcement.delete',
    addHomework: 'admin.batches.homework.store',
    listHomework: 'admin.batches.homework.list',
    deleteHomework: 'all', // TODO: Permissions not available
    updateHomework: 'all', // TODO: Permissions not available
    detailsHomework: 'all', // TODO: Permissions not available
    openHomeworkStudentStatus: 'all', // TODO: Permissions not available
    createScheduleV2: 'admin.batches.schedules.create',
    listSchedule: 'admin.batches.schedules.list',
    updateSchedule: 'admin.batches.schedules.update',
    deleteSchedule: 'admin.batches.schedules.delete',
    studentModify: 'admin.batches.students.store',
    listStudents: 'admin.batches.students.list',
    getListWithoutPhNo: 'admin.batches.students.list.withoutPhoneNumber',
    blockStudents: 'admin.batches.students.block-student',
    blockStudentChat: 'admin.batches.students.block-student-chat',
    removeBulkBatchStudent: 'admin.batches.students.remove-bulk',
    addBulkBatchStudent: 'admin.batches.students.store-bulk',
    deleteBatchStudents: 'admin.batches.students.deleteStudent',
    uploadScheduleSlides: 'admin.batches.schedules.slides',
    createScheduleSlides: 'admin.batches.schedules.slide.create',
    editScheduleSlides: 'admin.batches.schedules.slide.edit',
    publishScheduleSlides: 'admin.batches.schedules.slide.publish',
    deleteScheduleSlides: 'admin.batches.schedules.slide.delete',
    verifyScheduleSlides: 'admin.batches.schedules.slide.verification',
    uploadBatchScheduleSlides: 'admin.batches.schedules.slide.upload',
    downloadBatchScheduleSlides: 'admin.batches.schedules.slide.download',
    listingBatchScheduleSlides: 'admin.batches.schedules.slide.list',
    completeClass: 'admin.batches.schedules.complete-class',
    classReschedule: 'admin.batches.schedules.rescheduleClass',
    genScheduleCode: 'admin.batches.schedules.generate.schedule.code',
    createAddOns: 'admin.batches.addons.create',
    detailsAddOns: 'admin.batches.addons.details',
    listAddOns: 'admin.batches.addons.list',
    updateAddOns: 'admin.batches.addons.update',
    deleteAddOns: 'admin.batches.addons.delete',
    changeStatusAddOns: 'admin.batches.addons.change-status',
    createMahapackMapping: 'admin.batch_service.mahapack_mapping.create.v3',
    detailsMahapackMapping: 'admin.batch_service.mahapack_mapping.details.v3',
    listMahapackMapping: 'admin.batch_service.mahapack_mapping.list.v3',
    updateMahapackMapping: 'admin.batch_service.mahapack_mapping.update.v3',
    updateClickerMappingPermission: 'admin.batch_service.clicker.update',
    deleteMahapackMapping: 'admin.batch_service.mahapack_mapping.delete.v3',
    transferTag: 'admin.batches.tags.transfer',
    transferHomework: 'admin.batches.homework.transfer',
    transferSchedule: 'admin.batches.schedule.transfer',
    batchScheduleCancelStatus: 'all', // TODO: Permissions not available
    dynamicPlayerConfig: 'admin.batches.config.new_player',
    getInfinitePractice: 'admin.batches.infinitepractice.get',
    deleteInfinitePractice: 'admin.batches.infinitepractice.delete',
    updateInfinitePractice: 'admin.batches.infinitepractice.update',
    batchOffering: 'admin.batches.bulk.offerings',
    batchBulkPlansAccess: 'admin.batches.plans.bulkAccessPlanGeneric',
    getRoomBatch: 'admin.batches.batch-rooms.get',
    batchPlansBulkAccess: 'admin.batches.plans.bulkAccess',
    getPlanner: 'all',
    planList: 'admin.batches.plans.list',
    roomSubjectsList: 'admin.batches.room-subjects.teachers.list',
    getAiPersonalizationPermission:
        'admin.sahayak.ai-personalisation.upload-batch-meta-info',
    categoryList: 'admin.batches.students.categorylist',
    erpProgramsList: 'admin.batches.erp-programs.list',
    erpCentersList: 'admin.batches.erp-centers.list',
    importSchedule: 'admin.batches.schedules.import',
    actionBulkStudent: 'admin.batches.students.bulk-batch-access-multi-action',
    subTopicList: 'admin.lecture.subtopic.list',
    subTopicAdd: 'admin.lecture.subtopic.add',
    subTopicEdit: 'admin.lecture.subtopic.edit',
    subtopicDelete: 'admin.lecture.subtopic.delete',
    subtopicPublish: 'admin.lecture.subtopic.publish',
    updateBoostScorePermission: 'admin.batches.students.update-boosts',
    getBatchOffering: 'admin.batches.get-offerings',
    deleteBatchOffering: 'admin.batches.delete-batch-offerings',
};

export const OFFERING_TABLE = {
    createPlusTable: 'admin.batches.offeringTable.create-table',
    updatePlusTable: 'admin.batches.offeringTable.update-table',
    getPlusTable: 'admin.batches.offeringTable.get-table',
    getPlusTableItem: 'admin.batches.offeringTable.get-table-item',
    deletePlusTable: 'admin.batches.offeringTable.delete-table',
};

export const BATCH_ROOM = {
    createRoom: 'admin.batches.batch-rooms.store',
    updateRoom: 'admin.batches.batch-rooms.update',
    deleteRoom: 'admin.batches.batch-rooms.delete',
    uploadStudentInRoom: 'admin.batches.batch-rooms-students.store',
    previewRoomDetails: 'admin.batches.batch-rooms-students.get',
    roomStudentListing: 'admin.batches.batch-rooms-students.get',
    removeStudentFromRoom: 'admin.batches.batch-rooms-students.delete',
    roomSubjectMappingList: 'admin.batches.room-subjects.get',
    createRoomSubjectMapping: 'admin.batches.room-subjects.store',
    updateRoomSubjectMapping: 'admin.batches.room-subjects.update',
    deleteRoomSubjectMapping: 'admin.batches.room-subjects.delete',
};

export const BATCH_UNITS = {
    getUnits: 'admin.batches.units.list',
    createUnit: 'admin.batches.units.create',
    updateUnit: 'admin.batches.units.udate',
    deleteUnit: 'admin.batches.units.delete',
};

export const BATCH_CONFIG = {
    create: 'admin.batch_service.batch_config.create.v3',
    delete: 'admin.batch_service.batch_config.delete.v3',
    update: 'admin.batch_service.batch_config.update.v3',
    list: 'admin.batch_service.batch_config.list.v3',
    details: 'admin.batch_service.batch_config.details.v3',
    comparisonDetails:
        'admin.batch_service.batch_recommendation.recommended_batch_comparison_pointers.get.v3',
    pointersKeyName:
        'admin.batch_service.batch_recommendation.comparison_pointer_keynames.get.v3',
};

export const DEMO_VIDEOS = {
    create: 'admin.demo-videos.create',
    details: 'admin.demo-videos.details',
    list: 'admin.demo-videos.list',
    update: 'admin.demo-videos.update',
    delete: 'admin.demo-videos.delete',
};

export const BOOK_ACCESS = {
    list: 'admin.book.list',
    store: 'admin.book.store',
    update: 'admin.book.update',
    delete: 'admin.book.delete',
    toggleBook: 'admin.book.change-status',
    syncInventory: 'admin.book.inventory',
};

export const BOOK_TAGS_ACCESS = {
    list: 'all', // TODO: Permissions not available
    store: 'all', // TODO: Permissions not available
    update: 'all', // TODO: Permissions not available
    delete: 'all', // TODO: Permissions not available
};

export const REPORT_TAGS_ACCESS = {
    list: 'admin.error-tags.list',
    create: 'admin.error-tags.create',
    update: 'admin.error-tags.update',
    delete: 'admin.error-tags.delete',
};
export const SOURCE_FLOWS_ACCESS = {
    list: 'helpcentre.sources.get',
    create: 'helpcentre.sources.create',
    update: 'helpcentre.sources.update',
    delete: 'helpcentre.sources.delete',
    aiGuruEnable: 'helpcentre.level.enable-ai-guru-all',
};

export const SUBJECT_ACCESS = {
    list: 'all', // TODO: Permissions not available
    store: 'all', // TODO: Permissions not available
    update: 'all', // TODO: Permissions not available
    delete: 'all', // TODO: Permissions not available
    changeStatus: 'all', // TODO: Permissions not available
    listChapters: 'all', // TODO: Permissions not available
    subjectBulkDownload: 'admin.subject.download_bulk_excel',
    subjectBulkUpload: 'admin.subject.bulk_update_content',
};

export const BULK_COUPON_ACCESS = {
    list: 'admin.bulk_coupons.list',
    store: 'admin.bulk_coupons.store',
    update: 'admin.bulk_coupons.update',
    delete: 'admin.bulk_coupons.delete',
    download: 'admin.bulk_coupons.download',
};

export const BOOK_CATEGORY_ACCESS = {
    list: 'admin.book_category.list',
    store: 'admin.book_category.store',
    update: 'admin.book_category.update',
    delete: 'admin.book_category.delete',
    toggleCategory: 'admin.book_category.change-status',
};

export const COUPON_ACCESS = {
    list: 'admin.coupon.list',
    store: 'admin.coupon.store',
    update: 'admin.coupon.update',
    delete: 'admin.coupon.delete',
    upload: 'admin.coupon.bulk_upload',
    status: 'admin.coupon.change_status',
    download: 'admin.coupon.download_voucher',
    downloadUserExcel: 'admin.coupon.download-users-excel',
    createCouponItem: 'admin.coupon.create-coupon-items',
    deleteCouponItem: 'admin.coupon.delete-coupon-items',
    getCouponItems: 'admin.coupon.get-coupon-items',
    bulkUploadCouponItems: 'admin.coupon.bulk-upload-coupon-items',
};

export const CONTENT_RATING_ACCESS = {
    list: 'admin.content_rating.list',
    store: 'admin.content_rating.store',
    update: 'admin.content_rating.update',
    delete: 'admin.content_rating.delete',
    bookRating: 'admin.content_rating.book-rating',
};

export const CONTENT_CONSUMPTION_ACCESS = {
    list: 'admin.content_consumption.list',
    store: 'admin.content_consumption.store',
    update: 'admin.content_consumption.update',
    delete: 'admin.content_consumption.delete',
};

export const COHORT_ACCESS = {
    create: 'admin.cohort.create',
    list: 'admin.cohort.list',
    preference: 'admin.cohort.preference',
    update: 'admin.cohort.update',
    delete: 'admin.cohort.delete',
    batchList: 'admin.cohort.get_batch_list',
    assignBatch: 'admin.cohort.assign_batch',
    updatePriority: 'admin.cohort.update_priority',
    unassignBatch: 'admin.cohort.unassign_batch',
    banners: 'admin.cohort.bannner.list',
    partialUpdate: 'admin.cohort.partial_update',
};
export const JOBS_ACCESS = {
    getBulkJob: 'admin.bulk_upload_jobs.get',
    generateJobFile: 'admin.bulk_upload_jobs.generatefile',
    createUploadJob: 'admin.bulk_upload_jobs.create',
    getJobDetails: 'admin.bulk_upload_jobs.getdetails',
    // config
    uploadSampleFile: 'admin.bulk_upload_jobs.upload_sample_file',
    updateJobConfig: 'admin.bulk_upload_jobs.update_config',
    getJobConfig: 'admin.bulk_upload_jobs.get_configs',
    deleteJobConfig: 'admin.bulk_upload_jobs.delete_config',
};

export const COHORT_SUBJECT_MAPPING_ACCESS = {
    create: 'admin.cohort-subject-mapping.create',
    list: 'admin.cohort-subject-mapping.list',
    delete: 'admin.cohort-subject-mapping.delete',
    update: 'admin.cohort-subject-mapping.update',
};
export const COHORT_WIDGET_ACCESS = {
    create: 'admin.cohort-widget.create',
    list: 'admin.cohort-widget.list',
    delete: 'admin.cohort-widget.delete',
    update: 'admin.cohort-widget.update',
    genericWidget: 'admin.cohort-widget.all-courses.generic-widget',
    exploreWidget: 'admin.cohort-widget.explore',
    studyMaterialWidget: 'admin.cohort-widget.all-courses.study-material',
    bannerWidget: 'admin.cohort-widget.banner',
    allCoursesWidget: 'admin.cohort-widget.all-courses',
    testSeriesWidget: 'admin.cohort-widget.all-courses.test-series',
    trendingWidget: 'admin.cohort-widget.trending',
    testPassWidget: 'admin.cohort-widget.all-courses.test-pass,',
};
export const COHORT_ALAKH_AI_CONFIG = {
    create: 'admin.nebula.create.v1',
    get: 'admin.nebula.get.v1',
    update: 'admin.nebula.update.v1',
    upload: 'admin.nebula.upload_config.v1',
    getNotifications: 'admin.nebula.notification.list.v1',
    updateNotification: 'admin.nebula.notification.update.v1',
    createNotification: 'admin.nebula.notification.create.v1',
};

export const WIDGET_ACCESS = {
    create: 'admin.widget.store',
    list: 'admin.widget.list',
    update: 'admin.widget.update',
    delete: 'admin.widget.delete',
    changeStatus: 'admin.widget.change_status',
};

export const WIDGET_COMPONENT_ACCESS = {
    create: 'admin.widget_component.create',
    list: 'admin.widget_component.list',
    update: 'admin.widget_component.update',
    delete: 'admin.widget_component.delete',
    changeStatus: 'admin.widget_component.change_status',
    detail: 'admin.widget_component.details',
};

export const COMPANY_ACCESS = {
    create: 'admin.company.create',
    list: 'admin.company.list',
    details: 'admin.company.details',
    update: 'admin.company.update',
    delete: 'admin.company.delete',
};

export const TESTIMONIAL_ACCESS = {
    create: 'admin.testimonial.create',
    list: 'admin.testimonial.list',
    details: 'admin.testimonial.details',
    update: 'admin.testimonial.update',
    delete: 'admin.testimonial.delete',
};

export const DAILY_QUIZ_ACCES = {
    list: 'admin.daily_quizzes.list',
    store: 'admin.daily_quizzes.store',
    update: 'admin.daily_quizzes.update',
    delete: 'admin.daily_quizzes.delete',
};

export const STATE_ACCESS = {
    list: 'admin.states.list',
    create: 'admin.states.create',
    update: 'admin.states.update',
    delete: 'admin.states.delete',
    add_bulk_state: 'admin.states.bulk',
};

export const COLLEGE_ACCESS = {
    list: 'admin.colleges.list',
    create: 'admin.colleges.create',
    update: 'admin.colleges.update',
    delete: 'admin.colleges.delete',
    add_bulk_college: 'admin.colleges.bulk',
};

export const DAILY_UPDATE_ACCESS = {
    list: 'admin.daily_updates.list',
    store: 'admin.daily_updates.store',
    delete: 'admin.daily_updates.delete',
    update: 'admin.daily_updates.update',
};

export const DOWNLOAD_SECTION_ACCESS = {
    list: 'admin.download.list',
    store: 'admin.download.store',
    update: 'admin.download.update',
    delete: 'admin.download.delete',
};

export const DELIVERY_PIN_CODE_ACCESS = {
    list: 'admin.delivery_pincodes.list',
    store: 'admin.delivery_pincodes.store',
    update: 'admin.delivery_pincodes.update',
    delete: 'admin.delivery_pincodes.delete',
    download: 'admin.delivery_pincodes.download',
    downloadSample: 'admin.delivery_pincodes.download_sample',
};

export const MENTORSHIP_ROOM = { list: 'admin.buddy_room.list' };

export const DRIVE_SECURE_BULK_ACCESS = {
    list: 'admin.drive_secure_bulk.list',
    store: 'admin.drive_secure_bulk.store',
    create: 'admin.drive_secure_bulk.create',
};

export const STUDIO_ACCESS = {
    create: 'admin.studio.machine.create',
    list: 'admin.studio.machine.get',
    update: 'admin.studio.machine.update',
    getScheduleMapping: 'admin.studio.machine.getScheduleMachineMapping',
    deleteScheduleMapping: 'admin.studio.machine.deleteScheduleMachineMapping',
    appVersionCreate: 'admin.studio.appversion.create',
    appVersionUpdate: 'admin.studio.appversion.update',
    appVersionList: 'admin.studio.appversion.get',
    teacherXLogs: 'admin.studio.logs.get',
    allLectures: 'admin.studio.all_teacherX_lectures.get',
    yt: 'admin.studio.ythistory.list',
};

export const BATCH_AUDIT = { logs: 'admin.batches.activity_logs' };

export const STUDIO_LOCATIONS = {
    create: 'admin.studio.locations.post',
    list: 'admin.studio.locations.get',
    update: 'admin.studio.locations.put',
    delete: 'admin.studio.locations.delete',
};

export const STUDIO_CENTRES = {
    create: 'admin.studio.centers.post',
    list: 'admin.studio.centers.get',
    update: 'admin.studio.centers.put',
    delete: 'admin.studio.centers.delete',
};
export const STUDIO_ROOMS = {
    create: 'admin.studio.rooms.post',
    list: 'admin.studio.rooms.get',
    update: 'admin.studio.rooms.put',
    delete: 'admin.studio.rooms.delete',
};

export const DOUBT_ACCESS = {
    list: 'admin.doubts.list',
    store: 'admin.doubts.store',
    update: 'admin.doubts.update',
    delete: 'admin.doubts.delete',
};

export const DOUBT_CATEGORY_ACCESS = {
    store: 'admin.doubts_category.store',
    list: 'admin.doubts_category.list',
    details: 'admin.doubts_category.details',
    update: 'admin.doubts_category.update',
    delete: 'admin.doubts_category.delete',
};

export const DOUBT_TOPIC_ACCESS = {
    list: 'admin.doubts_topic.list',
    store: 'admin.doubts_topic.store',
    update: 'admin.doubts_topic.update',
    delete: 'admin.doubts_topic.delete',
};

export const DOUBT_STUDENT_ACCESS = {
    list: 'admin.doubts_student.list',
    store: 'admin.doubts_student.store',
    update: 'admin.doubts_student.update',
    delete: 'admin.doubts_student.delete',
};

export const EXAM_ACCESS = {
    list: 'admin.exam.list',
    store: 'admin.exam.store',
    update: 'admin.exam.update',
    delete: 'admin.exam.delete',
    changeStatus: 'admin.exam.change-status',
};

export const BATCH_FEE = {
    feeList: 'admin.fee.list',
    deleteFee: 'all', // TODO: Permissions not available
    updateFee: 'all', // TODO: Permissions not available
    createFee: 'all', // TODO: Permissions not available
};

export const FEEDS_ACCESS = {
    list: 'admin.feeds.list',
    store: 'admin.feeds.store',
    update: 'admin.feeds.update',
    delete: 'admin.feeds.delete',
};

export const FAQ_ACCESS = {
    list: 'admin.faq.list',
    store: 'admin.faq.store',
    update: 'admin.faq.update',
    delete: 'admin.faq.delete',
};

export const WEBINAR_ACCESS = {
    list: 'admin.vidyapeeth_master.getWebinarRecordings',
    store: 'admin.vidyapeeth_master.createWebinarRecordings',
    update: 'admin.vidyapeeth_master.updateWebinarRecordings',
    delete: 'admin.vidyapeeth_master.deleteWebinarRecordings',
};

export const WEBINAR_CATEGORY_ACCESS = {
    list: 'admin.vidyapeeth_master.getVideoCategory',
    store: 'admin.vidyapeeth_master.createVideoCategory',
    update: 'admin.vidyapeeth_master.updateVideoCategory',
    delete: 'admin.vidyapeeth_master.deleteVideoCategory',
    getOfferCourses: 'admin.vidyapeeth_master.getOfferCourses',
};

export const FAQ_CATEGORY_ACCESS = {
    list: 'admin.faq_category.list',
    store: 'admin.faq_category.store',
    update: 'admin.faq_category.update',
    delete: 'admin.faq_category.delete',
};

export const IN_APP_MESSAGE_ACCESS = {
    list: 'admin.inAppNotification.list',
    store: 'admin.inAppNotification.store',
    delete: 'admin.inAppNotification.delete',
    update: 'admin.inAppNotification.update',
};

export const INVOICE_ACCESS = {
    list: 'admin.invoice.list',
    multiple: 'admin.invoice.multiple',
    detail: 'admin.invoice.detail',
};

export const MCQ_ACCESS = {
    list: 'admin.mcq.list',
    store: 'admin.mcq.store',
    update: 'admin.mcq.update',
    delete: 'admin.mcq.delete',
};

export const NEWS_AND_BLOGS_ACCESS = {
    list: 'admin.news.list',
    store: 'admin.news.store',
    update: 'admin.news.update',
    delete: 'admin.news.delete',
};

export const ORDER_ACCESS = {
    list: 'admin.orders.list',
    details: 'admin.orders.detail',
    update: 'admin.orders.update',
    delete: 'admin.orders.deactivate_order',
    edit: 'admin.orders.extent_expiry_time',
    reValidateOrder: 'admin.orders.re-validate-order',
    bulkOrderUpdate: 'admin.orders.bulk_order_update',
    shiftOrderUser: 'admin.orders.shift_order_user',
    changeUserOrder: 'admin.orders.change_user_order',
};

export const ORDER_CANCELLATION_ACCESS = {
    list: 'admin.orderCancellation.list',
    detail: 'admin.orderCancellation.detail',
    resolve: 'admin.orderCancellation.resolve',
};

export const ORGANIZATION_ACCESS = {
    list: 'admin.organization.list',
    update: 'admin.organization.update',
    assignAccess: 'organizations.assign.update',
    index: 'scope.index',
    assign: 'scope.assign',
};

export const ORGANIZATION_PREFERENCE_ACCESS = {
    list: 'admin.organization.preferences.list',
    update: 'admin.organization.preferences.update',
    business_list: 'admin.organization.preferences.business-module.list',
    business_update: 'admin.organization.preferences.business-module.update',
    refer_list: 'admin.organization.preferences.refer-earn.list',
    refer_update: 'admin.organization.preferences.refer-earn.update',
};

export const ORGANIZATION_PREFERENCE_VIDEO_ACCESS = {
    list: 'admin.organization.video-preferences.list',
    update: 'dmin.organization.video-preferences.update',
};

export const PARENT_ACCESS = { list: 'admin.users.parent.list' };

export const PUBLICATION_ACCESS = {
    list: 'admin.publication.list',
    store: 'admin.publication.store',
    update: 'admin.publication.update',
    delete: 'admin.publication.delete',
    changeStatus: 'admin.publication.change-status',
};

export const PENPENCIL_VIDEO_ACCESS = {
    list: 'admin.videos.list',
    store: 'admin.videos.store',
    delete: 'admin.videos.delete',
    update: 'admin.videos.update',
    downloadRawFile: 'admin.videos.raw-file',
    resetVideoQualityZip: 'admin.videos.reset-quality-qnd-generate-zip',
};

export const PROGRAM_ACCESS = {
    list: 'admin.program.list',
    store: 'admin.program.store',
    update: 'admin.program.update',
    delete: 'admin.program.delete',
    downloadChapters: 'admin.program.download-chapters',
    toggleProgram: 'admin.program.change-status',
    sendContentNotification: 'admin.program.send_content_notification',
    uploadBulkProduct: 'admin.iap.upload.products',
    uploadBulkNudge: 'admin.users.upload-nudge',

    listInfinitePractice: 'admin.program.list_ip',
    createInfinitePractice: 'admin.program.create_ipconfig',
    deleteInfinitePractice: 'admin.program.delete_ipconfig',
    updateInfinitePractice: 'admin.program.update_ipconfig',
};

export const IAP_ACCESS = {
    list: 'admin.iap.app.list',
    price: 'admin.iap.price.list',
    country: 'admin.iap.country.list',
};

export const QBG_ACCESS = {
    category_configuration: 'admin.qbg.category_configuration',
    subjects: 'admin.qbg.subjects',
    chapters: 'admin.qbg.chapters',
    topics: 'admin.qbg.topics',
    subtopics: 'admin.qbg.subtopics',
};

export const COMMUNITY_ACCESS = {
    list: 'admin.community.getAllPrivateChannels',
    create: 'admin.community.create_private_channel',
    update: 'admin.community.updatePrivateChannel',
    delete: 'admin.community.deletePrivateChannel',
    uploadUserCsv: 'admin.community.update_users_csv',
    downloadUserCsv: 'admin.community.download_users_csv',
    listPrivateChannelUsers: 'admin.community.fetch_channel_users',
    updateUserActions: 'admin.community.update_user_actions',
};

export const QUESTION_TAGS_ACCESS = {
    list: 'admin.test_category.list',
    store: 'admin.test_category.store',
    update: 'admin.test_category.update',
    delete: 'admin.test_category.delete',
};

export const QRCODE_ACCESS = {
    list: 'admin.qrcode.list',
    store: 'admin.qrcode.store',
    update: 'admin.qrcode.update',
    delete: 'admin.qrcode.delete',
    generateQrcode: 'admin.qrcode.generate-qrcode',
    bulkQrcode: 'admin.qrcode.generate-bulk-qrcode',
};

export const REWARD = {
    list: 'admin.coupon.list',
    store: 'admin.coupon.store',
    update: 'admin.coupon.update',
    delete: 'admin.coupon.delete',
};

export const REPORT_ACCESS = {
    list: 'admin.report.list',
    userReport: 'admin.report.list',
    parentReport: 'admin.report.parent-report',
    userAssignedReport: 'admin.report.assigned-report',
    orderReport: 'admin.report.order-report',
    packageReport: 'admin.report.package-report',
    enquiryReport: 'admin.report.enquiry-report',
    questionEnquiryReport: 'admin.report.questions-enquiry-report',
    newsReport: 'admin.report.news-report',
    contentReport: 'admin.report.content-report',
    referReport: 'admin.report.refer-report',
    batchReport: 'admin.report.batch-report',
    testReport: 'admin.report.test-report',
    mmtReport: 'admin.report.make-my-test-report',
    pdfTestReport: 'admin.report.pdf-test-report',
    testReportFirst500: 'admin.report.test-report-first-500',
    batchStudentReport: 'admin.report.batch-users',
    batchTestReport: 'admin.report.batch-test-report',
    batchScheduleReport: 'admin.report.batch-class-wise-report',
    batchStudentScheduleReport: 'admin.report.batch-student-schedule-report',
    batchScheduleAttendanceReport:
        'admin.report.batch-schedule-attendance-report',
    uninstallReport: 'admin.report.uninstall-report',
    videoTagReport: 'admin.report.video-tag-report',
    userAccessReport: 'admin.report.teacher-access-report',
    userNotLoginReport: 'admin.report.user-not-login_report',
    applicationUsersReport: 'admin.report.user-application_report',
};

export const STORE_ACCESS = {
    list: 'admin.store.list',
    store: 'admin.store.store',
    update: 'admin.store.update',
    delete: 'admin.store.delete',
    bulkAssign: 'admin.v3.package.assign',
};

export const PACKAGE_ADDONS_ACCESS = {
    list: 'admin.packages.addons.list',
    create: 'admin.packages.addons.create',
    update: 'admin.packages.addons.update',
    delete: 'admin.packages.addons.delete',
};

export const SUBSCRIBER_ACCESS = {
    list: 'admin.subscriber.list',
    store: 'admin.subscriber.store',
    update: 'admin.subscriber.update',
    delete: 'admin.subscriber.delete',
};

export const STUDENT_ACCESS = {
    create: 'admin.users.store',
    list: 'admin.users.student.list',
    delete: 'admin.users.delete',
    update: 'admin.users.update',
    resetPassword: 'admin.users.reset-password',
    details: 'admin.users.user-detail',
    upload: 'admin.users.upload-student',
    uploadSchool: 'admin.users.upload-school-student',
    uploadRewards: 'admin.users.upload-reward',
    uploadCohortTriggerPopup: 'admin.users.upload-trigger-cohort-popup',
    blockStudents: 'admin.users.block-students',
    block: 'admin.users.block.update',
    unblock: 'admin.users.unblock.update',
    assignStore: 'admin.users.assign.store',
    assignList: 'admin.users.assign.list',
    activePacks: 'admin.users.active-packs',
    assignUpdate: 'admin.users.assign.update',
    extentOrder: 'admin.orders.extent_expiry_time',
    deactivateOrder: 'admin.orders.deactivate_order',
    assignDelete: 'admin.users.assign.delete',
    download: 'admin.users.download',
    v2usersList: 'admin.users.student.list.v2',
    v2usersCreate: 'admin.users.student.create.v2',
    bulkUnblockStudentsFromChat: 'admin.users.users-chat-unblock',
    addRole: 'admin.users.role.add',
    bulkCreate: 'admin.users.bulk-store',
};

export const MULTI_TEST = {
    testList: 'admin.test_series.test_category.multi_test.v3',
};

export const TEST_ACCESS = {
    list: 'admin.test.list',
    resultCalculate: 'admin.test.recalculate-result',
    studentList: 'admin.test.students',
    resetTest: 'admin.test.reset-test',
    downloadTest: 'admin.test.download-test-questions',
    downloadQuestions: 'admin.test_series.test.download_questions.v3',
    uploadQuestions: 'admin.test_series.test.upload_questions.v3',
    uploadQuestionResponses:
        'admin.test_series.test.upload_question_responses.v3',
    sheetFormat: 'admin.test_series.test.sheet_format.v3',
    sheetStatus: 'admin.test_series.test.sheet_status.v3',
    createSetCount: 'admin.test_series.test_question_sets.create_sets.v3',
    getSetCount: 'admin.test_series.test_question_sets.set_count.v3',
    getTestQuestionDetails:
        'admin.test_series.test_question.question_details.v3',
    listV3: 'admin.test_series.test_category.tests.list.v3',
    createV3: 'admin.test_series.test.create.v3',
    updateV3: 'admin.test_series.test.update.v3',
    deleteV3: 'admin.test_series.test.delete.v3',
    resultCalculateV3: 'admin.test_series.test.recalculate_result.v3',
    detailsV3: 'admin.test_series.test.details.v3',
    changeStatusV3: 'admin.test_series.test.change_status.v3',
    studentListV3: 'admin.test_series.test.students.v3',
    downloadSetPaper: 'admin.test_series.test_question_sets.question_paper.v3',
    downloadSubjectiveResult:
        'admin.test_series.test.download_subjective_result.v3',
    bulkUploadSubjectiveResult:
        'admin.test_series.test.bulk_upload_subjective_result.v3',
    downloadQuestionBankExerciseQuestion: 'admin.test.download-qbank-questions',
    getEnableQBGQuestions: 'admin.test_series.test.enable_qbg_questions.v3',
    subjectiveBulkResponseUpload:
        'admin.test_series.test.upload_subjective_responses.v3',
    subjectiveBulkResponseDownload:
        'admin.test_series.test.download_subjective_responses.v3',
    subjectiveBulkResponseFormate: 'admin.test_series.test.sheet_format.v3',
    syncQbgQuestions: 'admin.test_series.test.sync_qbg_questions.v3',
};

export const TEST_QUESTIONS_V1 = {
    list: 'admin.questions.list',
    create: 'admin.questions.create',
    update: 'admin.questions.update',
    delete: 'admin.questions.delete',
    details: 'admin.questions.get',
    bulkUpload: 'admin.questions.bulk-upload',
    textUpload: 'admin.questions.text-upload',
};

export const TEST_QUESTIONS_V3 = {
    list: 'admin.test_series.questions.list.v3',
    create: 'admin.test_series.questions.create.v3',
    update: 'admin.test_series.questions.update.v3',
    delete: 'admin.test_series.questions.delete.v3',
};

export const TEST_SECTION_V1 = {
    list: 'admin.sections.list',
    create: 'admin.sections.create',
    update: 'admin.sections.update',
    delete: 'admin.sections.delete',
    details: 'admin.sections.get',
};

export const TEST_SECTION_V3 = {
    list: 'admin.test_series.test_sections.list.v3',
    create: 'admin.test_series.test_sections.create.v3',
    update: 'admin.test_series.test_section.update.v3',
    delete: 'admin.test_series.test_sections.delete.v3',
    details: 'admin.test_series.test_section.details.v3',
};

export const TEST_CATEGORY_ACCESS = {
    list: 'admin.test_series.test_category.list.v3',
    store: 'admin.test_series.test_category.create.v3',
    update: 'admin.test_series.test_category.update.v3',
    delete: 'admin.test_series.test_category.delete.v3',
    changeStatus: 'admin.test_series.test_category.change_status.v3',
    listCohortMapping: 'admin.test_series.cohort_mapping.list.v3',
    createCohortMapping: 'admin.test_series.cohort_mapping.create.v3',
    updateCohortMapping: 'admin.test_series.cohort_mapping.update.v3',
    deleteCohortMapping: 'admin.test_series.cohort_mapping.delete.v3',
    createStudyMaterialTag: 'admin.test_series.study_material_tag.create.v3',
    listStudyMaterialTag: 'admin.test_series.study_material_tag.list.v3',
    updateStudyMaterialTag: 'admin.test_series.study_material_tag.update.v3',
    deleteStudyMaterialTag: 'admin.test_series.study-material_tag.delete.v3',
    createStudyMaterial: 'admin.test_series.study_material.create.v3',
    updateStudyMaterial: 'admin.test_series.study_material.update.v3',
    deleteStudyMaterial: 'admin.test_series.study-material.delete.v3',
    listTestCategoryMode: 'admin.test_series.test_category_mode.list.v3',
    createTestCategoryMode: 'admin.test_series.test_category_mode.create.v3',
    updateTestCategoryMode: 'admin.test_series.test_category_mode.update.v3',
    deleteTestCategoryMode: 'admin.test_series.test_category_mode.delete.v3',
    deleteTestSeries: 'admin.test_series.test_category.delete.v3',
    studyMaterialList: 'admin.test_series.study_material.list.v3',
    bulkTestCategoryModeAccess:
        'admin.test_category.students.bulk-test-categoy-access',
};

export const TEST_RANK_ACCESS = {
    list: 'admin.test_rank.list',
    store: 'admin.test_rank.store',
    update: 'admin.test_rank.update',
    delete: 'admin.test_rank.delete',
    download: 'admin.test_rank.download',
};

export const TEACHER_ACCESS = { list: 'admin.users.teacher.list' };

export const WEB_PREFERENCE_ACCESS = {
    list: 'admin.webpref.list',
    store: 'admin.webpref.store',
    centers: 'admin.webpref.centers',
};

export const LOGIN_USER_MAPPING = {
    deleteAllUserMapping:
        'admin.login_user_mapping.delete-all-login-user-mapping',
};

export const LIVE_STREAM_ACCESS = {
    create: 'admin.liveStream.create',
    start: 'admin.liveStream.start',
    fetch: 'admin.liveStream.fetch',
    stop: 'admin.liveStream.stop',
    delete: 'admin.liveStream.delete',
    harvest_fetch: 'admin.liveStream.harvestJob.fetch',
};

export const MENTORSHIP_STUDENTS_ACCESS = {
    delete: 'admin.buddy_students.delete',
};

export const MENTORSHIP_ROOM_PLAN_ACCESS = {
    create: 'admin.buddy_plan.create',
    list: 'admin.buddy_plan.list',
    details: 'admin.buddy_plan.details',
    update: 'admin.buddy_plan.update',
    delete: 'admin.buddy_plan.delete',
};

export const MENTORSHIP_ROOM_SCHEDULE_ACCESS = {
    create: 'admin.buddy_schedule.create',
    list: 'admin.buddy_schedule.list',
    details: 'admin.buddy_schedule.details',
    update: 'admin.buddy_schedule.update',
    delete: 'admin.buddy_schedule.delete',
};

export const MENTORSHIP_ROOM_MENTOR_ACCESS = {
    create: 'admin.buddy_mentor.create',
    list: 'admin.buddy_mentor.list',
    details: 'admin.buddy_mentor.details',
    update: 'admin.buddy_mentor.update',
    delete: 'admin.buddy_mentor.delete',
};

export const DOUBT_CONNECT_ROOM_PLAN_ACCESS = {
    create: 'admin.doubt_connect_plan.create',
    list: 'admin.doubt_connect_plan.list',
    details: 'admin.doubt_connect_plan.details',
    update: 'admin.doubt_connect_plan.update',
    delete: 'admin.doubt_connect_plan.delete',
};

export const DOUBT_CONNECT_ROOM_MENTOR_ACCESS = {
    create: 'admin.doubt_connect_mentor.create',
    list: 'admin.doubt_connect_mentor.list',
    details: 'admin.doubt_connect_mentor.details',
    update: 'admin.doubt_connect_mentor.update',
    delete: 'admin.doubt_connect_mentor.delete',
};

export const BATCH_CATEGORY_ACCESS = {
    store: 'admin.batches_category.store',
    list: 'admin.batches_category.list',
    update: 'admin.batches_category.update',
    delete: 'admin.batches_category.delete',
};

export const BHARAT_VIDEO_ACCESS = {
    list: 'admin.batch-schedules.schedule.get',
};

export const BATCH_ALERTING_ACCESS = {
    list: 'admin.batches_category_config.get',
};

export const BATCH_MULTI_ACCESS = { list: 'admin.multibatch.list' };

export const SDUI_ACCESS = { list: 'admin.sdui_master.getSDUIData' };

export const BATCH_MENTORS_ACCESS = {
    create: 'admin.mentorship.add_mentor',
    bulkCreate: 'admin.mentorship.import_mentors',
    list: 'admin.mentorship.get_mentors_list',
    update: 'admin.mentorship.update_mentor',
    delete: 'admin.mentorship.delete_mentor',
    assign: 'admin.mentorship.assign_mentors',
    mentors_list_batch: 'admin.mentorship.mentors_list_batch',
    get_batches: 'admin.mentorship.get_batches',
};

export const BATCH_MENTORSHIP_GROUPS_ACCESS = {
    create: 'admin.mentorship.create_group',
    list: 'admin.mentorship.group_list',
    update: 'admin.mentorship.update_group',
    delete: 'admin.mentorship.delete_group',
    getSettings: 'admin.mentorship.get_settings',
    postSettings: 'admin.mentorship.post_settings',
    bulkAssignMembers: 'admin.mentorship.import_members',
    listMentors: 'admin.mentorship.mentors_list',
    addMentors: 'admin.mentorship.add_mentors_group',
    removeMentors: 'admin.mentorship.remove_mentor_group',
    listStudents: 'admin.mentorship.get_students_groups',
    addStudents: 'admin.mentorship.add_students_group',
    removeStudents: 'admin.mentorship.remove_students_group',
    elevateStudentToMentor: 'admin.mentorship.elevate_student_mentor',
};

export const PATHSHALA_CENTER_ACCESS = {
    store: 'admin.pathshala_center.create',
    list: 'admin.pathshala_center.list',
    update: 'admin.pathshala_center.update',
    delete: 'admin.pathshala_center.delete',
    listId: 'admin.pathshala_batch_center_mapping.list-id',
    store_mapping: 'admin.pathshala_batch_center_mapping.create',
    list_mapping: 'admin.pathshala_batch_center_mapping.list',
    update_mapping: 'admin.pathshala_batch_center_mapping.update',
    delete_mapping: 'admin.pathshala_batch_center_mapping.delete',
};

export const SAARTHI_ACCESS = {
    list: 'admin.saarthi.list.v3',
    create: 'admin.saarthi.create.v3',
    delete: 'admin.saarthi.delete.v3',
    update: 'admin.saarthi.update.v3',
    students: 'admin.saarthi.students.v3',
    dashboard: 'admin.saarthi.dashboard.v3',
    detail: 'admin.saarthi.detail.v3',
    create_mapping_order: 'admin.saarthi.create_mapping_order.v3',
    add_bulk_student: 'admin.saarthi.add_bulk_student.v3',
    assign_bulk_students: 'admin.saarthi.assign_bulk_students.v3',
    change_student_slot: 'admin.saarthi.change-student-slot.v3',
    delete_bulk_students: 'admin.saarthi.bulk_access_remove.v3',
    slots: 'admin.saarthi.saarthi_slots.get.v3',
};
export const SAARTHI_MENTOR = {
    create: 'admin.saarthi.mentor.create.v3',
    list: 'admin.saarthi.mentor.list.v3',
    blockMentorStudent: 'admin.saarthi.mentor.block_student.v3',
    listMentorStudents: 'admin.saarthi.mentor.mentor_students.v3',
    update: 'admin.saarthi.mentor.update.v3',
    replaceMentor: 'admin.saarthi.mentor.replace_mentor.v3',
    delete: 'admin.saarthi.mentor.delete.v3',
    bulkMentorReplace: 'all', // TODO: Permissions not available
    changeSlot: 'all', // TODO: Permissions not available
    revokeAccess: 'all', // TODO: Permissions not available
    chatRoomList: 'admin.chat_rooms.list',
    chatList: 'admin.get_chat.list',
    insertChat: 'admin.insert_chat.create',
};

export const SAARTHI_MENTOR_FEEDBACK_ACCESS = {
    list: 'admin.saarthi.feedback.list.v3',
    delete: 'admin.saarthi.feedback.delete.v3',
    update: 'admin.saarthi.feedback.update_status.v3',
};

export const SAARTHI_SUBJECT_ACCESS = {
    list: 'admin.saarthi.subject.list.v3',
    delete: 'admin.saarthi.subject.delete.v3',
    update: 'admin.saarthi.subject.update.v3',
    create: 'admin.saarthi.subject.create.v3',
    detail: 'admin.saarthi.subject.detail.v3',
};

export const SAARTHI_PLAN_ACCESS = {
    list: 'admin.saarthi.plan.list.v3',
    delete: 'admin.saarthi.plan.delete',
    update: 'admin.saarthi.plan.update.v3',
    create: 'admin.saarthi.plan.create.v3',
};

export const SAARTHI_COORDINATOR_ACCESS = {
    list: 'admin.saarthi.coordinator.list.v3',
    delete: 'admin.saarthi.coordinator.delete.v3',
    update: 'admin.saarthi.coordinator.update.v3',
    create: 'admin.saarthi.coordinator.create.v3',
};

export const REELS = {
    creatorsList: 'admin.reels.creators.list',
    creatorsAdd: 'admin.reels.creators.create',
    creatorsDelete: 'admin.reels.creators.delete',
    creatorsUpdate: 'admin.reels.creators.list',
    feedPostList: 'admin.reels.feed-posts.list',
    feedPostAdd: 'admin.reels.feed-posts.create',
    feedPostDelete: 'admin.reels.feed-posts.delete',
    feedPostUpdate: 'admin.reels.feed-posts.update',
    feedPostReportList: 'admin.reels.feed-posts-reports.list',
    commentsList: 'admin.comments.get',
    commentsAdd: 'admin.comments.add',
    commentsDelete: 'admin.comments.delete',
    commentsUpdate: 'admin.comments.update',
    commentsReportList: 'admin.comments.reporthistory',
};

export const ADMIN_ANNOUNCEMENT = {
    delete: 'admin.announcement.delete',
    create: 'admin.announcement.store',
    list: 'admin.announcement.list',
    update: 'admin.announcement.update',
    details: 'admin.announcement.details',
};

export const LOAN_BUDDY = {
    form: 'admin.form.loan-buddy.get-user-application-data',
    docList: 'admin.form.loan-buddy.get-user-files',
    applicantList: 'admin.form.loan-buddy.get-list-of-applications',
    updateStatus: 'admin.form.loan-buddy.update-user-application',
};

export const BANK = {
    create: 'admin.form.loan-buddy-bank.create',
    list: 'admin.form.loan-buddy-bank.get-all-offers',
    update: 'admin.form.loan-buddy-bank.update',
    delete: 'admin.form.loan-buddy-bank.delete',
};

export const USER_APPLICATION_BANK_MAPPING = {
    updateSanctionedLoanAmount:
        'admin.form.user-application-bank-mappings.update-loan-amount',
    applicationStatus:
        'admin.form.user-application-bank-mappings.get-loan-application-status',
};

export const BANNERS_ACCESS = {
    list: 'admin.list.banner',
    create: 'admin.create.banner',
    update: 'admin.update.banner',
    delete: 'admin.delete.banner',
};
export const BANNER_PACKAGE = {
    list: 'admin.list.banner.package',
    create: 'admin.create.banner.package',
    update: 'admin.update.banner.package',
    delete: 'admin.delete.banner.package',
};

export const VIRTUAL_USER_MAPPING = {
    create: 'admin.users.virtualuser.create.v2',
    list: 'admin.users.virtualuser.get.v2',
    update: 'admin.users.virtualuser.update.v2',
};

export const PW_CLIENT_S2S = {
    create: 'admin.clients.create',
    list: 'admin.clients.list',
    updatePwClient: 'admin.clients.update',
    updateIPsToBeWhiteListed: 'admin.clients.update',
    delete: 'admin.clients.delete',
    getPwClientDetail: 'admin.clients.detail',
    revealSecretofPwClient: 'admin.clients.client_secret',
};

export const NUGGETS_ACCESS = {
    list: 'admin.pitara.nuggets.search.v3',
    create: 'admin.pitara.nuggets.create.v3',
    update: 'admin.pitara.nuggets.update.v3',
    delete: 'admin.pitara.nuggets.delete.v3',
    approve: 'admin.pitara.nuggets.approve.v3',
    resolveReports: 'admin.pitara.nuggets.resolve_reports.v3',
    getNuggetMetaData: 'admin.pitara.nuggets.metadata.v3',
    getExperienceMetaData: 'admin.pitara.experiences.metadata.get.v3',
    listExperience: 'admin.pitara.experiences.list.v3',
    getExperienceById: 'admin.pitara.experiences.get.v3',
    createExperience: 'admin.pitara.experiences.create.v3',
    updateExperience: 'admin.pitara.experiences.update.v3',
    deleteExperience: 'admin.pitara.experiences.delete.v3',
    createIcons: 'admin.pitara.icons.create.v3',
    listIcons: 'admin.pitara.icons.list.v3',
};

export const PW_TALK_ACCESS = {
    nuggetList: 'admin.talk.nuggets.search.v3',
    moduleList: 'admin.talk.modules.search.v3',
};

export const ADMIN_BATCH_PLANNER = {
    bulkUploadBatchPlanner: 'admin.batch_service.batch_planner.create.v3',
    erpBulkCorrection: 'admin.script.erp-bulk-correction',
    getCurrentPlannerForBatchSubject:
        'admin.batch_service.batch_planner.current_planner.v3',
    attendanceManualUpload: 'admin.institute.attendanceManualUpload',
    totalStudyDaysManualUpload: 'admin.attendance.attendanceManualUpload',
};

export const SUGGESTIONS_ACCESS = {
    create: 'admin.program.create_suggestion',
    update: 'admin.program.update_suggestion',
    list: 'admin.program.get_suggestion',
    delete: 'admin.program.delete_suggestion',
    changeStatus: 'admin.program.changeStatus_suggestion',
};

export const CONVERSATION = {
    emojiList: 'admin.chat.list',
    emojiCreate: 'admin.emoji.create',
    blockWords: 'admin.block_unblock_words',
    closeRoom: 'admin.close_room',
    delete: 'admin.delete_chat.delete',
};

export const ORG_ANNOUNCEMENTS_ACCESS = {
    create: 'admin.organization.announcement.create',
    update: 'admin.organization.announcement.update',
    list: 'admin.organization.announcement.list',
};

export const USER_GROUPS_ACCESS = {
    create: 'all',
    update: 'all',
    list: 'all',
    delete: 'all',
    listUsers: 'all',
    addUser: 'all',
    removeUser: 'all',
};

export const NOTICE_ACCESS = {
    create: 'all',
    update: 'all',
    list: 'all',
    delete: 'all',
};

export const ADMISSION_YEARS_ACCESS = {
    list: 'admin.year.list',
    create: 'admin.year.store',
    update: 'admin.year.update',
    delete: 'admin.year.delete',
};

export const HELPCENTER_ACCESS = {
    get_preferences: 'helpcentre.preferences.get',
    get_chat_flow_tree: 'helpcentre.flows.get',
};

export const SAT_CATAGORY = {
    list: 'admin.vidyapeeth_master.getList',
    create: 'admin.vidyapeeth_master.create',
    update: 'admin.vidyapeeth_master.updateCategory',
    delete: 'admin.vidyapeeth_master.deleteCategory',
    testCatagory: 'all', // TODO: Permissions not available
    detail: 'admin.vidyapeeth_master.findSatDataDetail',
    addTimeMode: 'admin.vidyapeeth_master.createTimingMode',
    registrartionForm: 'admin.vidyapeeth_master.createRegistrationForm',
    virality: 'admin.vidyapeeth_master.getFetchFrames',
    metaData: 'admin.vidyapeeth_master.createMetaData',
    uploadUserRegistrartion: 'admin.vidyapeeth_master.uploadUserRegistration',
    phaseHandlerCreate: 'admin.vidyapeeth_master.addPhase',
    phaseHandlerUpdate: 'admin.vidyapeeth_master.addPhase',
    phaseHandlerList: 'admin.vidyapeeth_master.getPhase',
    phaseHandlerActive: 'admin.vidyapeeth_master.getActivePhase',
    getAdmitCard: 'admin.vidyapeeth_master.getAdmitCard',
    getScoreCard: 'admin.vidyapeeth_master.customGetScoreCard',
    addScoreCard: 'admin.vidyapeeth_master.customAddScoreCard',
    uploadUserRegistration: 'admin.vidyapeeth_master.uploadUserRegistration',
    downloadUserRegistration: 'admin.vidyapeeth_master.DownloadExcelFile',
    uploadPercentile: 'admin.vidyapeeth_master.postScholarship',
    getPercentileList: 'admin.vidyapeeth_master.getScholarship',
    removeVirality: 'admin.vidyapeeth_master.removeFrame',
    updateVirality: 'admin.vidyapeeth_master.updateFrame',
    createNextLevelUserEligibility:
        'admin.vidyapeeth_master.createNextLevelUserEligibility',
    createInterviewUserEligibility:
        'admin.vidyapeeth_master.createInterviewUserEligibility',
    downloadNextLevelUserEligibility:
        'admin.vidyapeeth_master.downloadNextLevelUserEligibilityCSV',
    downloadInterviewUserEligibility:
        'admin.vidyapeeth_master.downloadInterviewUserEligibilityCSV',
    banUsersFromInterview: 'admin.vidyapeeth_master.banUsersFromInterview',
    banUsersFromLevel2: 'admin.vidyapeeth_master.banUsersFromLevel2',
    getAllSlotsInterview: 'admin.vidyapeeth_master.v1.get.interview.slots',
    updateSlotCapacity: 'admin.vidyapeeth_master.v1.update.slot.capacity',
    assignTeachersInterviewSlots:
        'admin.vidyapeeth_master.v1.assign.interview.teachers',
    updateNewInterviewSlots: 'admin.vidyapeeth_master.v1.add.interview.slots',
    uploadResultInterview: 'admin.vidyapeeth_master.v1.upload.result.interview',
    deleteInterviewSlot: 'admin.vidyapeeth_master.v1.delete.slot',
    getInterviewBookings: 'admin.vidyapeeth_master.v1.get.interview.bookings',
    unblockById: 'admin.vidyapeeth_master.unblockByBlockId',
    blockPhaseUsersCount: 'admin.vidyapeeth_master.blockPhaseUsersCount',
    blockedUsersCategoryList: 'admin.vidyapeeth_master.blockUsersCategoryList',
    addOfferCourses: 'admin.vidyapeeth_master.addOfferCourses',
    updateOfferCourses: 'admin.vidyapeeth_master.updateOfferCourses',
    deleteOfferCourses: 'admin.vidyapeeth_master.deleteOfferCourses',
    getExamByCategory: 'admin.vidyapeeth_master.getExamsByCategory',
    uploadCenterMapping: 'admin.pathshala_center.upload_centers_mapping',
    getPathshalaCenterMapping: 'admin.pathshala_center.list_centers_mapping',
    downloadPathshalaCenterMapping:
        'admin.pathshala_center.download_centers_mapping',
    syncCenterMapping: 'admin.pathshala_center.sync_centers_mapping',
};

export const OFFLINE_CATEGORY = {
    citiesList: 'admin.cities.get',
    deleteCategory: 'admin.vidyapeeth_master.deleteCategory',
    create: 'admin.vidyapeeth_master.create',
    listCityMapping: 'admin.vidyapeeth_master.listCityMapping',
    createCityMapping: 'admin.vidyapeeth_master.createCityMapping',
    updateCityMapping: 'admin.vidyapeeth_master.updateCityMapping',
    deleteCityMapping: 'admin.vidyapeeth_master.deleteCityMapping',
    getCityMapping: 'admin.vidyapeeth_master.getCityMapping',
    getAttachCategory: 'admin.vidyapeeth_master.getAttachCategory',
    listCenterTypeOfferings: 'admin.vidyapeeth_master.listCenterTypeOfferings',
    deleteCenterType: 'admin.vidyapeeth_master.deleteCenterType',
    deleteCenterTypeOfferings:
        'admin.vidyapeeth_master.deleteCenterTypeOfferings',
    updateCategory: 'admin.vidyapeeth_master.updateCategory',
    createOfflineVertical: 'admin.vidyapeeth_master.createOfflineVertical',
    listCenterType: 'admin.vidyapeeth_master.listOfflineVerticals',
    getCenterType: 'admin.vidyapeeth_master.getOfflineVertical',
    createCenterTypeOfferings:
        'admin.vidyapeeth_master.createCenterTypeOfferings',
    createVerticalExam: 'admin.vidyapeeth_master.createVerticalExam',
    deleteVerticalExam: 'admin.vidyapeeth_master.deleteVerticalExam',
    updateVerticalExam: 'admin.vidyapeeth_master.updateVerticalExam',
    getVerticalExam: 'admin.vidyapeeth_master.getVerticalExam',
    listVerticalExams: 'admin.vidyapeeth_master.listVerticalExams',
    getCenterTypeOfferings: 'admin.vidyapeeth_master.getCenterTypeOfferings',
    updateOfflineVertical: 'admin.vidyapeeth_master.updateOfflineVertical',
    updateCenterType: 'admin.vidyapeeth_master.updateOfflineVertical',
    getOfflineVertical: 'admin.vidyapeeth_master.getOfflineVertical',
    deleteOfflineVertical: 'admin.vidyapeeth_master.deleteOfflineVertical',
    createCenterType: 'admin.vidyapeeth_master.createOfflineVertical',
    updateCenterTypeOfferings:
        'admin.vidyapeeth_master.updateCenterTypeOfferings',
    listOfflineVerticals: 'admin.vidyapeeth_master.listOfflineVerticals',
    getValue: 'admin.vidyapeeth_master.getValue',
};

export const TEST_PASS = {
    create: 'admin.pass.create',
    list: 'admin.pass.list',
    update: 'admin.pass.update',
};

export const PAY_PLAN = {
    create: 'admin.pay_plan.create',
    list: 'admin.pay_plan.list',
    update: 'admin.pay_plan.update',
    upload: 'admin.pay_plan.bulkPayPlan',
};

export const JOB_ALERT = {
    create: 'admin.job.create.v1',
    update: 'admin.job.edit.v1',
    list: 'admin.job.list.v1',
    delete: 'admin.job.delete.v1',
};

export const BATTLEGROUND_ACCESS = {
    list: 'admin.test.battleground.list',
    create: 'admin.test.battleground.create',
    update: 'admin.test.battleground.update',
    delete: 'admin.test.battleground.delete',
    changeBattlegroundStatus: 'all',
    battlegroundInfoCreate: 'admin.test.battleground.info-create',
    battlegroundInfoList: 'admin.test.battleground.info-get',
};

export const STUDENT_FORM_ACCESS = {
    list: 'all', // TODO: Permissions not available
    create: 'all', // TODO: Permissions not available
    update: 'all', // TODO: Permissions not available
    delete: 'all', // TODO: Permissions not available
    uploadBatchCSV: 'all', // TODO: Permissions not available
    entityMapping:
        'admin.form.user-form-entity-mapping.get-user-form-entity-mapping',
    exportUserResponse: 'all', // TODO: Permissions not available
    uploadMarkAsInvalid: 'all', // TODO: Permissions not available
    uploadGoogleFormResponse: 'all', // TODO: Permissions not available
};

export const BATCH_SCHEDULES_ACCESS = {
    list: 'all',
    create: 'all',
    update: 'admin.batches.batch-subject.update-subject',
    delete: 'all',
};

export const EVAL_DASHBOARD_ACCESS = {
    list: 'admin.vidyapeeth_master.getEvalSessions',
    downloadAllResponse: 'admin.vidyapeeth_master.downloadEvalSessions',
    resolve: 'admin.vidyapeeth_master.resolveEvalSessions',
    retry: 'admin.vidyapeeth_master.retryEvalSessions',
    bulkUploadEvalFile: 'admin.vidyapeeth_master.manualUploadEvalSessions',
};

export const INFINITE_LEARNING = {
    getBatchOffering: 'admin.batches.offeringPage.get-batch-offerings',
    deleteBatchOffering: 'admin.batches.offeringPage.delete-batch-offering',
    getBatchOfferingById: 'admin.batches.offeringPage.get-batch-offering-by-id',
    updateBatchOffering:
        'admin.batches.offeringPage.update-batch-offering-by-id',
    createBatchOffering: 'admin.batches.offeringPage.create-offering',
};

export const COACH_MARK = {
    coachMark: 'all',
    pageList: 'admin.engagement.getallpages',
    pageCreate: 'admin.engagement.createpage',
    pageUpdate: 'admin.engagement.updatepage',
    PageDelete: 'admin.engagement.deletepage',
    coachMarkList: 'admin.engagement.getallcoachmarks',
    coachMarkCreate: 'admin.engagement.createcoachmarks',
    coachMarkUpdate: 'admin.engagement.updatecoachmark',
    coachMarkDelete: 'admin.engagement.deletecoachmark',
    updateUserSegment: 'admin.engagement.updateusersegment',
};

export const DOUBT_SME_ACCESS = {
    smeList: 'all',
    smeCreate: 'all',
    smeUpdate: 'all',
    smeDelete: 'all',
    smeLeadList: 'all',
    smeLeadCreate: 'all',
    smeLeadUpdate: 'all',
    smeLeadDelete: 'all',
    smeSubRoleList: 'admin.sme_subrole.list',
    smeSubRoleCreate: 'admin.sme_subrole.create',
    smeSubRoleUpdate: 'admin.sme_subrole.update',
    smeSubRoleDelete: 'admin.sme_subrole.delete',
};

export const SCHOLAR = {
    bulkUploadScholar: 'admin.batches.student.bulk-scholar',
    deleteScholar: 'admin.batches.student.bulk-scholar.update',
};

export const SUBJECT_EXPERTISE = {
    list: 'admin.subjectExpertise.get',
    create: 'admin.subjectExpertise.create',
    update: 'admin.subjectExpertise.update',
    delete: 'admin.subjectExpertise.delete',
};

export const LEVEL_UP_ACCESS = {
    getLevel: 'admin.engagement.learntoearn.listlevels',
    createLevel: 'admin.engagement.learntoearn.createlevel',
    updateLevel: 'admin.engagement.learntoearn.updatelevel',
    getSegments: 'admin.engagement.learntoearn.listsegments',
    createSegments: 'admin.engagement.learntoearn.createsegments',
    updateSegments: 'admin.engagement.learntoearn.updatesegment',
    deleteSegments: 'admin.engagement.learntoearn.deletesegment',
    getFeatures: 'admin.engagement.learntoearn.listfeatures',
    createFeatures: 'admin.engagement.learntoearn.createfeatures',
    updateFeatures: 'admin.engagement.learntoearn.updatefeatures',
    getProfiling: 'admin.student-engagement-core.listpage',
    updateProfiling: 'admin.student-engagement-core.updatepage',
};

export const MARGDARSHAK = {
    bulkUploadTeacher: 'admin.mentorship.margdarshak.teacher_student.upload',
    downloadTeacherList:
        'admin.mentorship.margdarshak.teacher_student.download',
    teacherList: 'admin.mentorship.margdarshak.teacher.list',
    teacherSearch: 'admin.mentorship.margdarshak.teacher.search',
    tagsCreate: 'admin.mentorship.margdarshak.tags.create',
    tagsList: 'admin.mentorship.margdarshak.tags.list',
    tagsDetails: 'admin.mentorship.margdarshak.tags.details',
    tagsDelete: 'admin.mentorship.margdarshak.tags.delete',
    studentCreate: 'admin.mentorship.margdarshak.teacher.students.create',
    studentUpload: 'admin.mentorship.margdarshak.teacher.students.upload',
    studentDownload: 'admin.mentorship.margdarshak.teacher.students.download',
    studentList: 'admin.mentorship.margdarshak.teacher.students.list',
    studentSearch: 'admin.mentorship.margdarshak.teacher.students.search',
    teacherDetail: 'admin.mentorship.margdarshak.teacher.details',
    studentDetail: 'admin.mentorship.margdarshak.teacher.students.details',
    studentTransfer: 'admin.mentorship.margdarshak.teacher.students.transfer',
    studentRemove: 'admin.mentorship.margdarshak.teacher.students.remove',
};

export const THREE_D_MODEL_ACCESS = {
    list: 'admin.three_d_model.list',
    create: 'admin.three_d_model.create',
    update: 'admin.three_d_model.update',
    delete: 'admin.three_d_model.delete',
};

export const COHORT_EVENT_ACCESS = {
    list: 'admin.cohort_event.list',
    create: 'admin.cohort_event.create',
    update: 'admin.cohort_event.update',
    delete: 'admin.cohort_event.delete',
    upload: 'admin.cohort_event.bulk_create',
};

export const SLIDE_IMAGE_ACCESS = {
    list: 'admin.slide-image.list',
    create: 'admin.slide-image.create',
    update: 'admin.slide-image.update',
    delete: 'admin.slide-image.delete',
    details: 'admin.slide-image.detail',
    reprocess: 'admin.slide-image.reprocess',
    listAnnotation: 'admin.slide-annotation.list',
    createAnnotation: 'admin.slide-annotation.create',
    updateAnnotation: 'admin.slide-annotation.update',
    deleteAnnotation: 'admin.slide-annotation.delete',
};

export const WEBINAR_UNIGO = {
    list: 'admin.live_kit.recordings_list',
    download: 'all',
    upload: 'all',
};
export const RFID_MACHINE_ACCESS = {
    list: 'admin.vidyapeeth_master.machine',
    create: 'admin.vidyapeeth_master.machine',
    update: 'admin.vidyapeeth_master.machine',
    delete: 'admin.vidyapeeth_master.machine',
};

export const ANIMATIONS = {
    list: 'admin.animation.list',
    create: 'admin.animation.add',
    update: 'admin.animation.update',
    delete: 'admin.animation.delete',
};

export const BADGES = {
    list: 'admin.badge.list',
    create: 'admin.badge.add',
    update: 'admin.badge.update',
    delete: 'admin.badge.delete',
};

export const OTT_SUBSCRIPTION = {
    planList: 'admin.ott.subscription_plan.list',
    planCreate: 'admin.ott.subscription_plan.create',
    planDetail: 'admin.ott.subscription_plan.detail',
    planUpdate: 'admin.ott.subscription_plan.update',
    planDelete: 'admin.ott.subscription_plan.delete',
};

export const OTT_BROWSE = {
    list: 'admin.ott.widget.list',
};

export const OTT_VIDEO = {
    list: 'admin.ott.video.list',
    create: 'admin.ott.video.create',
    update: 'admin.ott.video.update',
};

export const OTT_PLAYLIST = {
    list: 'admin.ott.playlist.list',
    create: 'admin.ott.playlist.create',
    update: 'admin.ott.playlist.update',
};

export const OTT_TEACHER = {
    list: 'admin.ott.teacher.list',
    create: 'admin.ott.teacher.create',
    update: 'admin.ott.teacher.update',
    delete: 'admin.ott.teacher.delete',
};

export const OTT_BULK_UPLOAD = {
    jobList: 'admin.ott.jobs.list',
    getBulkUploadStatus: 'admin.ott.jobs.bulk_upload_status',
    startBulkUpload: 'admin.ott.jobs.start_upload_process',
};

export const MULTIPLE_THUMBNAIL_UPLOAD = {
    getMultipleSignedUrls: 'files.multipleS3SignedUrl',
};

export const LIBRARY_REVAMP_ACCESS = {
    create: 'admin.widget_component.create_widget',
    edit: 'admin.widget_component.edit_widget',
    list: 'admin.widget_component.get_widgets',
    delete: 'admin.widget_component.delete_widget',
    getFilters: 'admin.widget_component.get_filters',
    allotConfig: 'admin.widget_component.allot_config',
    getSingleWidget: 'admin.widget_component.get_widget',
};

export const CLONE_TEST = { create: 'admin.test_series.test.clone_test.v3' };
export const UPLOAD_TEST_GROUP = {
    listTestGroup: 'admin.test_series.test_groups.list.v3',
    createTestGroup: 'admin.test_series.test_groups.create.v3',
    editTestGroup: 'admin.test_series.test_groups.update_group.v3',
    deleteTestGroup: 'admin.test_series.test_groups.delete_group.v3',
    listCollection: 'admin.test_series.test_groups.list_collections.v3',
    createCollection: 'admin.test_series.test_groups.create_collection.v3',
    editCollection: 'admin.test_series.test_groups.update_collection.v3',
    deleteCollection: 'admin.test_series.test_groups.delete_collection.v3',
};

export const AI_NCERT_ACCESS = {
    subjectList: 'admin.ai_ncert.listsubjects',
    subjectCreate: 'admin.ai_ncert.createsubject',
    subjectUpdate: 'admin.ai_ncert.updatesubject',
    subjectDelete: 'admin.ai_ncert.deletesubject',
    subjectDetails: 'admin.ai_ncert.getsubject',
    bookList: 'admin.ai_ncert.listbooks',
    bookCreate: 'admin.ai_ncert.createbook',
    bookUpdate: 'admin.ai_ncert.updatebook',
    bookDelete: 'admin.ai_ncert.deletebook',
    bookDetails: 'admin.ai_ncert.getbook',
    chapterList: 'admin.ai_ncert.listchapters',
    chapterCreate: 'admin.ai_ncert.createchapter',
    chapterUpdate: 'admin.ai_ncert.updatechapter',
    chapterDelete: 'admin.ai_ncert.deletechapter',
    chapterDetails: 'admin.ai_ncert.getchapter',
    sectionList: 'admin.ai_ncert.listsections',
    sectionCreate: 'admin.ai_ncert.createsection',
    sectionUpdate: 'admin.ai_ncert.updatesection',
    sectionDelete: 'admin.ai_ncert.deletesection',
    sectionDetails: 'admin.ai_ncert.getsection',
    videoList: 'admin.ai_ncert.listvideoexplainations',
    videoCreate: 'admin.ai_ncert.createvideoexplaination',
    videoUpdate: 'admin.ai_ncert.updatevideoexplaination',
    videoDelete: 'admin.ai_ncert.deletevideoexplaination',
    textList: 'admin.ai_ncert.listtextexplanations',
    textCreate: 'admin.ai_ncert.createtextexplanation',
    textUpdate: 'admin.ai_ncert.updatetextexplanation',
    textDelete: 'admin.ai_ncert.deletetextexplanation',
};

export const SUBSEQUENT_PAYMENT_SCHEMES_ACCESS = {
    list: 'admin.orders.list',
    create: 'admin.orders.create',
    update: 'admin.orders.Update',
    delete: 'admin.orders.delete',
    details: 'admin.orders.details',
    listByBatchCategoryIds: 'admin.orders.list-by-category-ids',
    listByBatchId: 'admin.orders.list-by-batch-id',
};

export const ONBOARDING_LAYER_ACCESS = {
    getByParentId: 'admin.cohort.onboarding_layer.get_by_parent_id',
    rootListing: 'admin.cohort.onboarding_layer.root_listing',
    //TODO will update with real permissions once available
    create: 'all',
    update: 'all',
    delete: 'all',
};

export const META_ACCESS = {
    'finance-exam-categoryList':
        'admin.organization.finance-exam-category.list',
    'finance-exam-categoryListDetails':
        'admin.organization.finance-exam-category.details',
    'finance-exam-categoryListCreate':
        'admin.organization.finance-exam-category.create',
    'finance-exam-categoryListDelete':
        'admin.organization.finance-exam-category.delete',
    'finance-exam-categoryListUpdate':
        'admin.organization.finance-exam-category.update',

    classList: 'admin.organization.class.list',
    classListCreate: 'admin.organization.class.create',
    classListDetails: 'admin.organization.class.details',
    classListUpdate: 'admin.organization.class.update',
    classListDelete: 'admin.organization.class.delete',

    examList: 'admin.organization.exam.list',
    examListCreate: 'admin.organization.exam.create',
    examListDetails: 'admin.organization.exam.details',
    examListUpdate: 'admin.organization.exam.update',
    examListDelete: 'admin.organization.exam.delete',

    boardList: 'admin.organization.board.list',
    boardListCreate: 'admin.organization.board.create',
    boardListDetails: 'admin.organization.board.details',
    boardListUpdate: 'admin.organization.board.update',
    boardListDelete: 'admin.organization.board.delete',

    streamList: 'admin.organization.stream.list',
    streamListCreate: 'admin.organization.stream.create',
    streamListDetails: 'admin.organization.stream.details',
    streamListUpdate: 'admin.organization.stream.update',
    streamListDelete: 'admin.organization.stream.delete',

    languageList: 'admin.organization.language.list',
    languageListCreate: 'admin.organization.language.create',
    languageListDetails: 'admin.organization.language.details',
    languageListUpdate: 'admin.organization.language.update',
    languageListDelete: 'admin.organization.language.delete',

    'exam-yearList': 'admin.organization.exam-year.list',
    'exam-yearListCreate': 'admin.organization.exam-year.create',
    'exam-yearListDetails': 'admin.organization.exam-year.details',
    'exam-yearListUpdate': 'admin.organization.exam-year.update',
    'exam-yearListDelete': 'admin.organization.exam-year.delete',

    'sub-examList': 'admin.organization.sub-exam.list',
    'sub-examListCreate': 'admin.organization.sub-exam.create',
    'sub-examListDetails': 'admin.organization.sub-exam.details',
    'sub-examListUpdate': 'admin.organization.sub-exam.update',
    'sub-examListDelete': 'admin.organization.sub-exam.delete',
};
